import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-3 container-fluid space-y-4" }
const _hoisted_2 = { class: "bg-white rounded-xl shadow-md p-3" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-center gap-3" }
const _hoisted_4 = { class: "flex items-center gap-3 w-full" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "text-xl font-bold mb-1 text-slate-800" }
const _hoisted_8 = { class: "mb-0 text-xs text-slate-500" }
const _hoisted_9 = { class: "bg-white rounded-xl shadow-md" }
const _hoisted_10 = { class: "p-3 mb-2 space-y-2" }
const _hoisted_11 = { class: "text-lg font-bold text-slate-800" }
const _hoisted_12 = { class: "divide-y divide-gray-200 list-none pb-4" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex items-center gap-3 py-2 mx-3" }
const _hoisted_15 = { class: "h-16 w-16 rounded-lg shadow-xl flex items-center justify-center border" }
const _hoisted_16 = { class: "flex-1 text-left" }
const _hoisted_17 = { class: "text-xs font-semibold text-gray-700" }
const _hoisted_18 = {
  key: 0,
  class: "text-sm md:text-lg font-semibold uppercase text-gray-700"
}
const _hoisted_19 = {
  key: 1,
  class: "text-sm md:text-lg font-semibold uppercase text-gray-700"
}
const _hoisted_20 = { class: "text-xs line-clamp-1" }
const _hoisted_21 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DetalleMensajesView = _resolveComponent("DetalleMensajesView")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.acreditado && _ctx.acreditado.foto ? _ctx.acreditado.foto : require('@/assets/img/nologo.png'),
              class: "shadow-sm w-16 rounded-lg"
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.acreditado ? _ctx.acreditado.nombre + " " +
              _ctx.acreditado.apellido : _ctx.$t('label.cargando')), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('label.fecha.alta')) + " : " + _toDisplayString(_ctx.acreditado ?
              _ctx.formatDate(_ctx.acreditado.fechaAlta, 'dd/MM/yyyy HH:mm:ss') : _ctx.$t('label.cargando')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.$t('menu.mensajes')), 1)
        ]),
        _createElementVNode("ul", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mensajesFiltrados, (item, i) => {
            return (_openBlock(), _createElementBlock("li", {
              onClick: ($event: any) => (_ctx.mostrarConversacion(item)),
              key: i,
              class: "hover:bg-gradient-to-r from-gray-200 to-gray-50 cursor-pointer"
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.getIcono(item),
                    class: "text-2xl"
                  }, null, 8, ["icon"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatDate(item.fechaAlta, 'dd/MM/yyyy hh:mm:ss')), 1),
                  (item.acreditadoDe.id === _ctx.acreditado.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(item.acreditadoPara.nombre + ' ' + item.acreditadoPara.apellido), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(item.acreditadoDe.nombre + ' ' + item.acreditadoDe.apellido), 1)),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t(item.mensaje)), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['far', 'fa-eye'],
                    class: "text-2xl mr-2 text-gray-500"
                  })
                ])
              ])
            ], 8, _hoisted_13))
          }), 128))
        ])
      ])
    ]),
    (_ctx.detalleConversacionVisible)
      ? (_openBlock(), _createBlock(_component_DetalleMensajesView, {
          key: 0,
          closeFunction: _ctx.closeDialogConversacion,
          acreditado: _ctx.acreditado,
          mensaje: _ctx.mensajeSeleccionado
        }, null, 8, ["closeFunction", "acreditado", "mensaje"]))
      : _createCommentVNode("", true),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"])
  ], 64))
}